module.exports = __webpack_public_path__ + "img/APERITIF.d5fc1c0a.png";